<template>
  <div class="meetingRecordDetail">
    <!-- 页头 -->
    <div class="page-header-style">
      <el-page-header @back="goBack" :content="$t('lang.title_meetingRecordDetail')"></el-page-header>
    </div>
    <!-- 信息显示 -->
    <div class="filters">
      <el-form ref="form" :model="form" label-width="120px" label-suffix=":" :inline="true">
        <!-- 赛事类别 -->
        <el-form-item :label="$t('lang.lab_competeCategory')">
          <span class="color-opacity80">{{ this.form.competeCategoryName|valueIsNull }}</span>
        </el-form-item>
        <!-- 比赛项 -->
        <el-form-item :label="$t('lang.lab_competeEvent')">
          <span class="color-opacity80">{{ this.form.eventName|valueIsNull }}</span>
        </el-form-item>
        <!-- 组别 -->
        <el-form-item :label="$t('lang.lab_competeGroup')">
          <span class="color-opacity80">{{ this.form.groupName|valueIsNull }}</span>
        </el-form-item>
        <!-- 年龄段 -->
        <el-form-item :label="$t('lang.lab_competeAgeGroup')">
          <span class="color-opacity80">{{ this.form.ageGroupName|valueIsNull }}</span>
        </el-form-item>
      </el-form>   
    </div>
    <!-- 筛选 -->
    <div class="filters">
      <el-form :inline="true" label-suffix=":">
        <!-- 搜索input -->
        <el-form-item :label="$t('lang.lab_searchfor')">
          <input style="display: none"/>
          <el-input v-model="keyWord" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_searchforname')"></el-input>
        </el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="onSearch(true,true)">{{$t('lang.btn_search')}}</el-button>
        <!-- 重置 -->
        <el-button type="primary" @click="onClear">{{$t('lang.btn_reset')}}</el-button>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-card>
      <!-- 导入导出 -->
      <el-upload
        ref="uploading"
        slot="header"
        action
        :on-remove="handleRemove"
        :on-change="handleSuccess"
        :on-exceed="outlimit"
        :on-error="uploadErr"
        :limit="1"
        accept=".xlsx"
        :file-list="fileList"
        :auto-upload="false">
        <el-button slot="trigger" size="primary" type="primary">{{$t('lang.btn_selectExcel')}}</el-button>
        <el-button style="margin-right: 10px;" size="primary" type="success" @click="onImport">{{$t('lang.btn_import')}}</el-button>
        <el-button style="margin-left: 10px;" size="primary" type="primary" @click="onExport">{{$t('lang.btn_export')}}</el-button>
      </el-upload>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @sort-change="changeTableSort"
      >
        <!-- 名次 -->
        <el-table-column prop="ranking" align="center" :label="$t('lang.lab_ranking')" :sortable="'custom'" width="100px"></el-table-column>
        <!-- 选手姓名 -->
        <el-table-column prop="playerName" :label="$t('lang.lab_playerName')" :sortable="'custom'"></el-table-column>
        <!-- 证件类型 -->
        <el-table-column prop="idType" :label="$t('lang.lab_certificateType')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{scope.row.idType.replace(new RegExp('0','g'),$t('lang.MeetingRecordDetail_idType[0].name')).replace(new RegExp('1','g'),$t('lang.MeetingRecordDetail_idType[1].name')).replace(new RegExp('2','g'),$t('lang.MeetingRecordDetail_idType[2].name')).replace(new RegExp('3','g'),$t('lang.MeetingRecordDetail_idType[3].name'))}}</span>
            <!-- 0: 身份证 -->
            <!-- <span v-if="scope.row.idType === '0'">{{$t('lang.MeetingRecordDetail_idType[0].name')}}</span> -->
            <!-- 1: 护照 -->
            <!-- <span v-if="scope.row.idType === '1'">{{$t('lang.MeetingRecordDetail_idType[1].name')}}</span> -->
            <!-- 2: 港澳身份证 -->
            <!-- <span v-if="scope.row.idType === '2'">{{$t('lang.MeetingRecordDetail_idType[2].name')}}</span> -->
            <!-- 3: 台胞证 -->
            <!-- <span v-if="scope.row.idType === '3'">{{$t('lang.MeetingRecordDetail_idType[3].name')}}</span> -->
          </template>
        </el-table-column>
        <!-- 证件号 -->
        <el-table-column prop="idCard" :label="$t('lang.lab_certificateNum')" :sortable="'custom'"></el-table-column>
        <!-- 赛事名称 -->
        <el-table-column prop="competeName" :label="$t('lang.lab_competeName')" :sortable="'custom'"></el-table-column>
        <!-- 比赛时间 -->
        <el-table-column prop="competeDate" :label="$t('lang.lab_raceTime')" :sortable="'custom'">
          <template slot-scope="scope">
            {{ scope.row.competeDate  | timeYMD }}
          </template>
        </el-table-column>
        <!-- 成绩 -->
        <el-table-column prop="result" :label="$t('lang.lab_result')" :sortable="'custom'">
          <template slot-scope="scope">
            <span>{{ scope.row.result | valueIsNull}}</span>
          </template>                
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:meetingRecordDetail
 *@Description:赛会记录详情
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-16
 */
import { excelDownload } from '../../config/download.js'

export default {
  name: '',
  components: {},
  data() {
    return {
      keyWord_bak: '', // 备份-赛事名称
      keyWord: '', // 关键字
      competeRecordSettingId: '', // 通过id查找赛会记录详情
      form: {
        competeCategoryName: '',
        eventName: '',
        groupName: '',
        ageGroupName: '',
      }, // 赛会记录信息数据
      /* 赛会记录详情的列表变量 */
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 列表数据
      /* 导出 */
      allData: [], 
      /* 导入 */
      uploadFile: '', // 文件
      fileList: [], // 上传
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 获取赛会记录详情列表数据
    getData() { 
      this.$get(`/competeRecord/recordPlayerList?isWeb=true&competeRecordSettingId=${this.competeRecordSettingId}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            // 赛会记录详情
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取赛会记录信息
    getInfoData() { 
      this.$get(`/competeRecord/recordDetail?competeRecordSettingId=${this.competeRecordSettingId}`).then(
        res => {
          if (res && res.code === 200) {
            this.form = res.data
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 重置
    onClear() {
      this.keyWord = ''
      this.keyWord_bak = ''
      this.pageNum = 1
      this.getData()
    },
    // 查询
    onSearch(flag, isSearch) { 
      if (flag) {
        this.pageNum = 1
      }
      if (isSearch) {
        // 记忆筛选项值
        this.keyWord_bak = this.keyWord
      } else { 
        // 筛选项正确显示
        this.keyWord = this.keyWord_bak
      }
      this.$get(`/competeRecord/recordPlayerList?isWeb=true&keyWord=${this.keyWord}&competeRecordSettingId=${this.competeRecordSettingId}&sortName=${this.sortName}&sortFieldName=${this.sortFieldName}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true)
    },
    // 获取全部数据
    getAllData() {
      this.$get(`/competeRecord/recordPlayerList?isWeb=true&competeRecordSettingId=${this.competeRecordSettingId}&sortName=${this.sortName}&sortFieldName=${this.sortFieldName}`).then(
        res => {
          if (res && res.code === 200) {
            // 赛会记录详情列表
            this.allData = res.data.list
            let newArr = []
            let time = ''
            let type = ''
            if (this.allData.length > 0) {
              for (let i = 0; i < this.allData.length; i++) {
                var date = new Date(this.allData[i].competeDate)
                var Y = date.getFullYear() 
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) 
                var D = date.getDate() > 9 ? date.getDate() : ('0' + date.getDate()) 
                time = Y + '-' + M + '-' + D 
                // 判断证件类型
                if (this.allData[i].idType === '0') {
                  type = this.$i18n.t('lang.MeetingRecordDetail_idType[0].name')
                } else if (this.allData[i].idType === '1') {
                  type = this.$i18n.t('lang.MeetingRecordDetail_idType[1].name')
                } else if (this.allData[i].idType === '2') {
                  type = this.$i18n.t('lang.MeetingRecordDetail_idType[2].name')
                } else if (this.allData[i].idType === '3') {
                  type = this.$i18n.t('lang.MeetingRecordDetail_idType[3].name')
                } 
                newArr.push({
                  ranking: this.allData[i].ranking,
                  playerName: this.allData[i].playerName,
                  idType: type,
                  idCard: this.allData[i].idCard,
                  competeName: this.allData[i].competeName,
                  competeDate: time,
                  exportResult: this.allData[i].exportResult,
                })
              }
            }
            // Excel表头
            const tHeader = [
              this.$i18n.t('lang.lab_ranking') + this.$i18n.t('lang.lab_rankingRule'),
              this.$i18n.t('lang.lab_star') + this.$i18n.t('lang.lab_playerName'),
              this.$i18n.t('lang.lab_star') + this.$i18n.t('lang.lab_certificateType'),
              this.$i18n.t('lang.lab_star') + this.$i18n.t('lang.lab_certificateNum'),
              this.$i18n.t('lang.lab_star') + this.$i18n.t('lang.lab_competeName'),
              this.$i18n.t('lang.lab_star') + this.$i18n.t('lang.lab_raceTime') + this.$i18n.t('lang.lab_dateRule'),
              this.$i18n.t('lang.lab_star') + this.$i18n.t('lang.lab_result') + this.$i18n.t('lang.lab_resultRule1'),
            ]
            // 对应table数据的列字段名
            const filterVal = [
              'ranking',
              'playerName',
              'idType',
              'idCard',
              'competeName',
              'competeDate',
              'exportResult',
            ]
            excelDownload(tHeader, filterVal, newArr, this.form.competeCategoryName + '-' + this.form.eventName + '-' + this.form.groupName + '-' + this.form.ageGroupName + '-' + this.$i18n.t('lang.lab_meetingRecordDetail'))
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 导出
    onExport() {
      if (navigator.onLine) {
        this.getAllData()
      } else {
        this.$message.error(this.$i18n.t('lang.warning_network'))
      }        
    },
    // 文件上传数量超过提醒
    outlimit() {
      this.$message.warning(this.$i18n.t('lang.warning_uploadLimit'))
    },
    // 文件移除
    handleRemove(file, fileList) {
      console.log('Remove Success!', file, fileList)
      this.fileList = []
      this.uploadFile.length = 0
    },
    // 文件上传
    handleSuccess(e) {
      console.log('Upload Success!', e)
      this.uploadFile = e.raw
    },
    // 上传文件的断网
    uploadErr() {
      if (!navigator.onLine || window.navigator.onLine === false) {
        const loading = this.$loading()
        setTimeout(() => {
          loading.close()
          this.$message.error(this.$i18n.t('lang.warning_network'))
        }, 500)
      }
    },
    // 导入
    onImport() {
      if (this.uploadFile.length < 1) {
        this.$message.warning(this.$i18n.t('lang.lab_pleaseSeletcDoc'))
      } else {
        let formData = new FormData()
        formData.append('competeRecordSettingId', this.competeRecordSettingId)
        formData.append('files', this.uploadFile)
        let loading = this.$loading()
        this.$postFormData(`/competeRecord/import/`, formData).then(
          res => {
            loading.close()
            if (res && res.code === 200) {
              this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
              this.onSearch(true)
              this.fileList = []              
            } else {
              this.$confirm(res.message, this.$i18n.t('lang.lab_prompt'),
                {
                  confirmButtonText: this.$i18n.t('lang.btn_confirm'),
                  cancelButtonText: this.$i18n.t('lang.btn_cancel'),
                  showCancelButton: false,
                  type: 'warning'
                }
              ).then(() => {           
                })
                .catch(() => {
                })  
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      }
    },
    // 返回
    goBack() {
      window.history.go(-1)
    }
  },
  created() {
    this.competeRecordSettingId = this.$route.query.id
    if (this.competeRecordSettingId !== '') {
      this.getData()
      this.getInfoData()
    }
  },
  mounted() {}
}
</script>

<style lang='scss'>
.meetingRecordDetail{
 .color-opacity80{
   color: #777777;
 }
 .filters .el-input__inner {
   width: 280px;
 }
}
</style>
